// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // baseUrl: 'http://192.168.0.106:8180',
  // baseUrl: 'http://localhost:8090'
  // baseUrl: 'http://localhost:8082'
  //  baseUrl: 'https://intranetpabaseuatoci.tvscredit.com/base/emicard'
   baseUrl:'https://emicard.tvscredit.com/emicard' //prod
    //baseUrl:'https://emicardoci.tvscredit.com/emicard'
  //http://192.168.0.105/
 
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
